<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" fill="none" viewBox="0 0 20 18"><path stroke="#000" stroke-width="2" d="M20 9H2M8.5 2l-7 7 7 7"/></svg>
</template>

<script>
  export default {
    name: "ArrowLeft"
  }
</script>

<style scoped>

</style>